/**
 * upgradeAddonModal.tsx
 */
import Addon from '@shared/classes/addon';
import AddonModalContainer from '../../atoms/container/addonModalContainer';
import AddonModalIcon from '../../atoms/images/addonModalIcon';
import AddonModalText from '../../atoms/text/AddonModalText';
import BackgroundMask from '../../atoms/mask/backgroundMask';
import QrGenerator from '../../elements/qr/qrGenerator';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import UpgradeAddonModalButtons from '../../elements/modal/upgradeAddonModalButtons';
import UpgradeAddonModalQrContainer from '../../atoms/container/upgradeAddonModalQrContainer';
import useCloseModalKeyboard from '../../../../shared/components/utils/hooks/useCloseModalKeyboard';
import { modalSelector } from '@shared/store/slices/modal.slice';
import { useAppSelector } from '@shared/store/hooks';
import { userSelector } from '@shared/store/slices/user.slice';

/**
 * Displays the upgrade addon modal.
 */
export default function UpgradeAddonModal() {
  const { params } = useAppSelector(modalSelector);
  const { operator } = useAppSelector(userSelector);
  const logo = (params as { addon: Addon })?.addon?.logoColor;
  const qrUrl = operator?.landing ? operator.landing : '';

  // Keyboard hooks

  useCloseModalKeyboard();

  return (
    <BackgroundMask opacity={1}>
      <AddonModalContainer>
        {logo ? <AddonModalIcon src={logo} /> : null}
        <AddonModalText>
          {TranslationManager.get('MODAL.UPGRADE_ADDON.TITLE')}
        </AddonModalText>
        {qrUrl ? (
          <>
            <AddonModalText>
              {TranslationManager.get('MODAL.UPGRADE_ADDON.SUBTITLE')}
            </AddonModalText>
            <UpgradeAddonModalQrContainer>
              <QrGenerator scale={1.4} url={operator?.landing} />
            </UpgradeAddonModalQrContainer>
          </>
        ) : null}
        <UpgradeAddonModalButtons />
      </AddonModalContainer>
    </BackgroundMask>
  );
}
